class RecoverCustomerPassword extends HTMLElement {
  /**
   * connectedCallback
   * @description called each time the element is added to the document. The specification recommends that, as far as possible, developers should implement custom element setup in this callback rather than the constructor.
   */
  connectedCallback() {
    const url = new URL(window.location.href);
    const params = new URLSearchParams(url.search);
    const email = params.get('email');
    if (email !== null && email !== '') {
      this.querySelector('input[name="email"]').value = email;
    }
  }
}

customElements.define('form-recover-customer-password', RecoverCustomerPassword);
